var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.875 14.875H16.125C15.4375 14.875 14.875 15.4375 14.875 16.125V24.875C14.875 25.5625 15.4375 26.125 16.125 26.125H24.875C25.5625 26.125 26.125 25.5625 26.125 24.875V16.125C26.125 15.4375 25.5625 14.875 24.875 14.875ZM24.875 16.125V24.875H16.125V16.125H24.875ZM19.9625 22.8313L21.8375 20.4125L24.25 23.625H16.75L18.625 21.2125L19.9625 22.8313Z",
    fill: "#CDD3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.b531b34d35894f44b3fe417879d10de3.svg";
export { ForwardRef as ReactComponent };